import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-square-work',
    templateUrl: './square-work.component.html',
    styleUrls: ['./square-work.component.scss']
})
export class SquareWorkComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
